import React from "react";
import PropTypes from 'prop-types';
import { Widget } from '@uploadcare/react-widget';
import Effects from 'uploadcare-widget-tab-effects';
import ImagePreview from "../ImagePreview";

const { REACT_APP_UPLOADCARE_KEY } = process.env;

function Uploader(props) {
  const { instanceNumber } = props;
  const divId = `Uploader${instanceNumber}`;
  const urlHiddenId = `Url${instanceNumber}`;
  const filenameHiddenId = `filename${instanceNumber}`;
  const widgetId = `uploaderWidget${instanceNumber}`;

  const fileTypeLimit = (allowedFileTypes) => {
    const types = allowedFileTypes.split(' ')

    return function (fileInfo) {
      if (fileInfo.name === null) {
        return
      }
      const extension = fileInfo.name.split('.').pop()

      if (extension && !types.includes(extension)) {
        throw new Error('fileType')
      }
    }
  }

  const validators = [fileTypeLimit('jpg jpeg png JPG JPEG PNG')];

  return (
    <div
      id={divId}
      className="ugc-contribution-modal__uploader ugc-contribution-modal__uploader-container">
      <input type="hidden"
             id={urlHiddenId}
             name="uploadUrls"/>
      <input type="hidden"
             id={filenameHiddenId}
             name="filenames"/>
      <ImagePreview instanceNumber={instanceNumber}/>
      <Widget
        key={instanceNumber}
        publicKey={REACT_APP_UPLOADCARE_KEY}
        validators={validators}
        inputAcceptTypes=".jpg, .jpeg, .png, .JPG, .JPEG, .PNG"
        id={widgetId}
        previewStep
        clearable="true"
        imagesOnly="true"
        tabs="file camera facebook gdrive gphotos dropbox instagram evernote flickr onedrive"
        effects="rotate"
        localeTranslations={{
          buttons: {
            choose: {
              images: {
                one: `Choose a photo (${props.uploaderCount} of 4)`
              }
            }
          },
          dialog: {
            tabs: {
              preview: {
                error: {
                  fileType: {
                    title: "Oops- we can't add that file",
                    text: "Please use a JPG or PNG file type",
                  }
                },
              },
            }
          }
        }}
        customTabs={{ preview: Effects }}
        onChange={() => {
          ShowImagePreview(instanceNumber);
          props.handleCallback();
        }}
        onFileSelect={(file) => {
          if (file === null) {
            RemoveImagePreview(instanceNumber);
            props.handleCallback(instanceNumber);
          }
        }}/>
    </div>
  );
}

const ShowImagePreview = (instanceNumber) => {
  const widget = document.getElementById(`uploaderWidget${instanceNumber}`);
  const widgetDiv = document.getElementById(`Uploader${instanceNumber}`);
  const previewWrapper = document.getElementById(`preview${instanceNumber}`);
  const img = document.getElementById(`imagePreview${instanceNumber}`);
  const urlHolder = document.getElementById(`Url${instanceNumber}`);
  const filenameHolder = document.getElementById(`filename${instanceNumber}`);
  const imgDescriptionLabel = document.querySelector(`[for="description${instanceNumber}"]`);
  const imgDescription = document.getElementById(`description${instanceNumber}`);
  const imgCaptionLabel = document.querySelector(`[for="caption${instanceNumber}"]`);
  const imgCaption = document.getElementById(`caption${instanceNumber}`);
  const previewUrl = `${widget.value}-/scale_crop/200x200/center`;

  previewWrapper.classList.remove('d-none');
  previewWrapper.classList.add('d-flex');
  img.setAttribute('src', previewUrl);
  img.style.setProperty('visibility', 'visible');
  imgDescription.classList.remove('d-none');
  imgDescriptionLabel.classList.remove('d-none');
  imgCaption.classList.remove('d-none');
  imgCaptionLabel.classList.remove('d-none');
  urlHolder.value = widget.value;
  const widgetTextValue = widgetDiv.querySelector('#uploadcare--widget__text .uploadcare--widget__file-name');
  filenameHolder.value = widgetTextValue.innerHTML;
};

const RemoveImagePreview = (instanceNumber) => {
  const previewWrapper = document.getElementById(`preview${instanceNumber}`);
  const img = document.getElementById(`imagePreview${instanceNumber}`);
  const urlHolder = document.getElementById(`Url${instanceNumber}`);
  const filenameHolder = document.getElementById(`filename${instanceNumber}`);
  const imgDescription = document.getElementById(`description${instanceNumber}`);
  const imgCaptionLabel = document.querySelector(`[for="caption${instanceNumber}"]`);
  const imgCaption = document.getElementById(`caption${instanceNumber}`);
  const imgDescriptionLabel = document.querySelector(`[for="description${instanceNumber}"]`);

  previewWrapper.classList.add('d-none');
  previewWrapper.classList.remove('d-flex');
  img.style.setProperty('visibility', 'hidden');
  img.setAttribute('src', '');
  imgDescription.classList.add('d-none');
  imgDescriptionLabel.classList.add('d-none');
  imgDescription.value = null;
  imgCaption.classList.add('d-none');
  imgCaptionLabel.classList.add('d-none');
  imgCaption.value = null;
  urlHolder.value = null;
  filenameHolder.value = null;
};

Uploader.propTypes = {
  instanceNumber: PropTypes.string,
};

export default Uploader;
